import { useEffect, useState, useRef, } from "react";
import { styled, } from "styled-components";
import { Flow, UIBase, } from "@bracket/ui/nodes";
import { Text, Icon as IconComponent, } from "@bracket/ui/components";
import * as ICONS from "@bracket/ui/icons";
import { gsap, } from "gsap";
import type { Selectable, } from "./atomic";


export declare type SelectButtonProps<T extends object = object> = {
	open: boolean;
	width: number;
	height: number;
	selected: Selectable | null;
	onClick: () => void;
	icon?: keyof typeof ICONS;
}



export const SelectButton = <T extends object = object>({
	open,
	width = "100%",
	height = "100%",
	icon = "Chevron",
	selected,
	onClick,
}: SelectButtonProps<T>) => {

	const ref = useRef<HTMLDivElement>(null);
	const iconRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if(ref.current) {
			// dispatch dimensions to parent
		}
	}, [ref.current]);

	useEffect(() => {
		if(iconRef.current) {
			gsap.to(iconRef.current, {
				rotation: open ? 0 : 180,
				duration: 0.3,
				ease: "power2.inOut",
			});
		}
	}, [iconRef.current, open]);

	return (
		<SelectButtonContainer
			ref={ref}
			$width={width}
			$open={open}
			onClick={onClick}>
			<ButtonContent>
				<Flow $flow="stream" $flexible $justify="center">
					<Text style={{ whiteSpace: "nowrap", }}>{ selected ? selected.label : "Select" }</Text>
				</Flow>
				<Icon ref={iconRef} icon={icon} height="12px" width="12px" />
			</ButtonContent>
		</SelectButtonContainer>
	)
}

const SelectButtonContainer = styled(UIBase)<{ $width: number; $open: boolean; }>`
	position: relative;
	width: ${({ $width }) => $width && $width !== -1 ? `${$width}px` : ""};
	height: ${({ $height }) => $height && $height !== -1 ? `${$height}px` : ""};
	border-radius: ${({ $open }) => $open ? "8px 8px 0px 0px;" : "8px;"};
`;

const ButtonContent = styled(Flow).attrs({ $flow: "stream", })`
	gap: 0.75rem;
	width: 100%;
	align-items: center;
	justify-content: center;
`;

export declare type IconProps = {
	icon: keyof typeof ICONS;
	height?: any;
	width?: any;
	ref?: React.RefObject<HTMLDivElement>;
}

const Icon = ({ icon, height, width, ref }: IconProps) => {
	const ICON = ICONS[icon];
	return (
		<IconFrame $height={height} $width={width} ref={ref}>
			<ICON />
		</IconFrame>
	)
}

const IconFrame = styled.div<{ $height: any; $width: any; }>`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	height: ${({ $height, }) => $height === -1 ? "100%" : `${$height}`};
	max-height: ${({ $height, }) => $height === -1 ? "100%" : `${$height}`};
	min-height: ${({ $height, }) => $height === -1 ? "100%" : `${$height}`};
	min-width: ${({ $width, }) => $width === -1 ? "100%" : `${$width}`};
	max-width: ${({ $width, }) => $width === -1 ? "100%" : `${$width}`};
`;
